import { useState } from 'react'

import {
  bestwesternChains,
  choiceChains,
  hiltonChains,
  hyattChains,
  ihgChains,
  marriottChains,
  radissonChains,
  sonestaChains,
  wyndhamChains
} from '../../main/hotelBrandsAndChains'

function getChains(brand) {
  switch (brand) {
    case 'ihg':
      return ihgChains

    case 'choice':
      return choiceChains

    case 'radisson':
      return radissonChains

    case 'wyndham':
      return wyndhamChains

    case 'marriott':
      return marriottChains

    case 'hilton':
      return hiltonChains

    case 'hyatt':
      return hyattChains

    case 'bestwestern':
      return bestwesternChains

    case 'sonesta':
      return sonestaChains

    default:
      break
  }
}

export const useChainOptions = () => {
  const [chainOptions, setChainOptions] = useState({})
  const [brand, setBrand] = useState()

  function handleChangeBrand(newBrand) {
    if (newBrand !== brand) {
      setBrand(newBrand)
      setChainOptions(newBrand === 'independent' ? {} : getChains(newBrand))
    }
  }

  return [chainOptions, handleChangeBrand]
}
